<template>
	<div>
		<div class="us_container">
			<div style="margin-top: 1.25rem;z-index: -1;">
				<img @click="checkVideoFun()" src="../../assets/static/images/bofang.png" style="position: absolute;left: 50%;margin-left: -32px;top: 50%;margin-top: -135px;width: 64px;height: 64px;cursor:pointer;z-index: 2;">
				<video style="max-height:650px;width: 100%; object-fit: cover;" src="https://kyxadmin.zkshare.com/Resource/video/kyx.mp4" autoplay="autoplay" loop="loop" muted="muted"></video>
			</div>
			<div>
		

				<div class='mask' v-if='videoState == true' @click='masksCloseFun'></div>

				<div class="videomasks" v-show="videoState == true" >
		<!-- <iframe style="width: 50rem;height: 31.25rem;" src="//player.bilibili.com/player.html?aid=633100800&bvid=BV1sb4y1y7sX&cid=412577728&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="false"> </iframe> -->
					<!-- <video :src='videoSrc' controls='controls' autoplay>
					您的浏览器不支持 video 标签。
					</video> -->
					<div id="vs" style="width: 31.25rem !important;height: 31.25rem !important;"></div>
				</div>
			</div>
			<!-- <div style="width: 100%;height: 12.5rem;display: flex;flex-direction: column;align-items: center;">
				<div style="width: 60rem;display: flex;line-height:35px" >
					<div style="width: 12rem;font-size: 32px;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">科颐轩</div>
					<p style="font-size: 22px;margin: 0;">
						是一家以物联网技术为核心、软硬件结合一体化的,实验室智能管理解决方案的提供商和运营服务商,荣获国家高新技术企业认证,公司长期以来专注于实验室管理领域,研发了国内领
					</p>
				</div>
				<p style="font-size: 22px;align-self: flex-start;margin-left: 470px;">
					先的高新技术产品——科颐轩实验室智能管理系统。
				</p>
				
			</div> -->
			<p style="margin: 2rem 0;" class="sub_menu_title">公司历程</p>
			<!-- <div class="us_list">
				<img class="us_img" src="../../assets/static/images/kyxlogo.png">
				<div style="margin-top: -2rem;margin-left: 2rem;">
					<p class="us_title">公司成立</p>
					<div class="us_msg">
						
						<p>
							广州市科颐轩电子科技有限公司成立于2013年
						</p>
						<p>是一家以物联网技术为核心、软硬件结合一体化的</p>
						<p>实验室智能管理解决方案的提供商和运营服务商</p>
						<p>荣获国家高新技术企业认证</p>
						<p></p>
						<p>公司长期以来专注于实验室管理领域</p>
						<p>研发了国内领先的高新技术产品——科颐轩实验室智能管理系统</p>
					</div>
				</div>
			</div> -->
			
			<div class="us_detail">
				<div class="us_detail_t">
					<div class="us_container_box">
					<div :class="runI==1?'us_box1 animate__animated animate__bounce':'us_box2'" >
						<div>
							<p class="us_box_title">成立</p>
							<p class="us_box_msg">Establish</p>
						</div>
						<p class="us_box_date">2013</p>
						<div :class="runI==1?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==1?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=1">
					</div>
					</div>
					<div class="us_container_box">
					<div :class="runI==2?'us_box1 animate__animated animate__bounce':'us_box2'">
						<div>
							<p class="us_box_title">起步</p>
							<p class="us_box_msg">Start</p>
						</div>
						<p class="us_box_date">2014-2015</p>
						<div :class="runI==2?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==2?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=2">
					</div>
					</div>
					<div class="us_container_box">
					<div :class="runI==3?'us_box1 animate__animated animate__bounce':'us_box2'" >
						<div>
							<p class="us_box_title">深耕</p>
							<p class="us_box_msg">Deep Ploughing</p>
						</div>
						<p class="us_box_date">2017</p>
						<div :class="runI==3?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==3?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=3">
					</div>
					</div>
					<div class="us_container_box">
					<div :class="runI==4?'us_box1 animate__animated animate__bounce':'us_box2'" >
						<div>
							<p class="us_box_title">腾飞</p>
							<p class="us_box_msg">Rise Rapidly</p>
						</div>
						<p class="us_box_date">2018-2019</p>
						<div :class="runI==4?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==4?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=4">
					</div>
					</div>
					<div class="us_container_box">
					<div :class="runI==5?'us_box1 animate__animated animate__bounce':'us_box2'" >
						<div>
							<p class="us_box_title">沉淀</p>
							<p class="us_box_msg">Precipitate</p>
						</div>
						<p class="us_box_date">2020</p>
						<div :class="runI==5?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==5?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=5">
					</div>
					</div>
					<div class="us_container_box">
					<div  :class="runI==6?'us_box1 animate__animated animate__bounce':'us_box2'" >
						<div>
							<p class="us_box_title">蓄势待发</p>
							<p class="us_box_msg">Ready To Go</p>
						</div>
						<p class="us_box_date">2021</p>
						<div :class="runI==6?'tri':'tri tri_hide'"></div>
					</div>
					<div :class="runI==6?'dot_lage animate__animated animate__flash':'dot_grey'" @mouseover="runI=6">
					</div>
					</div>
					<div class="line_dark">
					</div>
				</div>
			</div>
		</div>
		<div class="qualify_container">
			<p style="margin: 4rem 0;padding-top: 4rem;" class="sub_menu_title">公司资质</p>
			<div class="qualify_list">
				<div class="qualify_box">
					<img class="qualify_box_img" src="../../assets/static/images/e1.png" preview preview-text="莱博实验室管理系统V1.0">
					<p class="qualify_box_title">莱博实验室管理系统V1.0</p>
				</div>
				<div class="qualify_box">
					<img class="qualify_box_img" src="../../assets/static/images/e2.png" preview preview-text="中科联盟温度监测系统V1.0">
					<p class="qualify_box_title">中科联盟温度监测系统V1.0</p>
				</div>
				<div class="qualify_box">
					<img class="qualify_box_img" src="../../assets/static/images/e3.png" preview preview-text="中科联盟OA系统V1.0">
					<p class="qualify_box_title">中科联盟OA系统V1.0</p>
				</div>
				<div class="qualify_box">
					<img class="qualify_box_img" src="../../assets/static/images/e4.png" preview preview-text="科颐轩实验室智能管理系统V1.0">
					<p class="qualify_box_title">科颐轩实验室智能管理系统V1.0</p>
				</div>
			</div>
			</div>
			<div class="kyx_container">
				<div class="kyx_detail_top">
					<div>
						<p class="kyx_detail_top_title">100<sup class="kyx_detail_top_title_sup">+</sup></p>
						<p class="kyx_detail_top_msg">大型三甲医院</p>
					</div>
					<div>
						<p class="kyx_detail_top_title">30<sup class="kyx_detail_top_title_sup">+</sup></p>
						<p class="kyx_detail_top_msg">合作客户省市</p>
					</div>
					<div>
						<p class="kyx_detail_top_title">40<sup class="kyx_detail_top_title_sup">+</sup></p>
						<p class="kyx_detail_top_msg">官方资质认证</p>
					</div>
				</div>
				<p class="kyx_title">关于科颐轩</p>
				<p class="kyx_msg"><span style="margin-right: 50px;"></span>广州市科颐轩电子科技有限公司成立于2013年，是一家先进的物联网技术、互联网技术和实验室现代管理理念相结合的高新技术企业，长期以来专注于实验室管理领域，推出了国内领先的高新技术产品—科颐轩实验室智能化管理系统。</p>
				<p class="kyx_msg"><span style="margin-right: 50px;"></span>科颐轩凭借领先的产品化能力，坚持软硬件一体化研发技术体系，着重打造智能精细化管理能力，实现对实验室“人员、仪器设备、试剂耗材、环境、数据”的智能连接，助推实验室智能化管理水平。</p>
				<p class="kyx_msg"><span style="margin-right: 50px;"></span>公司拥有实验室管理顾问团队、资深的软硬件研发工程师团队、以及专业的销售、安装和售后团队，能够提供专业的技术支持。公司建立了规范的质量保证体系和售后服务体系，为用户带来优质的产品体验。截止目前，已累计100家大型三甲医院和高等院校选择了科颐轩的产品和服务。</p>
			</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../../utils/js/scrollAnimation.js';
	import Player from 'xgplayer';
	export default {
		data(){
			return{
				runI:1,
				 videoSrc:'',
				      		 videoState:false,
							
			}
		},
		created(){
			// const currentY = document.documentElement.scrollTop || document.body.scrollTop
			// scrollAnimation(currentY, 800)
			
		},
		mounted() {
			const player = new Player({
			    id: 'vs',
			    url: 'https://kyxadmin.zkshare.com/Resource/video/kyx.mp4',
				autoplay:false,
				width:800,
				height:500
			})
			console.log(player)
		},
		methods:{
		   		//点击按钮出现弹窗播放视频
		   			checkVideoFun(){
		   			this.videoState = true;
		   			this.videoSrc = '';
		   			},
		   			masksCloseFun(){
		   			this.videoState = false;
		   			}
		   		}
	}
</script>

<style lang="less" scoped>
	.us_container{
		.us_list{
			width: 75rem;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
		}
		.us_img{
			width: 36.5625rem;
			height: 19.75rem;
		}
		.us_title{
			font-size: 30px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.us_msg{
			font-size: 1.125rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 1rem;
			text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
			
		}
		.us_detail{
			width: 75rem;
			margin: 0 auto;
			margin-top: 5rem;
		}
		.us_detail_t{
			display: flex;
			justify-content: space-around;
			position: relative;
		}
		.us_box1{
			width: 8.6875rem;
			height: 11.75rem;
			background: #FFFFFF;
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08), 0 6px 20px 0 rgba(0, 0, 0, 0.08);
			display: flex;
			flex-direction: column;
			justify-content:space-around ;
			align-items: center;
			text-align: center;
			transform: rotateY(180deg);
			
			
			position: relative;
		}
		.us_box2{
			height: 188px;
			display: flex;
			flex-direction: column;
			justify-content:space-around ;
			align-items: center;
			text-align: center;
			
		}
		.us_box_title{
			font-size: 1.375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			margin: 0;
		}
		.us_box_msg{
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			margin: 0;
		}
		.us_box_date{
			font-size: 1.875rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			margin: 0;
			}
			.us_container_box{
				display: flex;
				flex-direction: column;
				align-items: center;
			}
			.dot_lage{
				width: 3.6875rem;
				height: 3.6875rem;
				background: linear-gradient(180deg, #54A1FD 0%, #2A68F9 100%);
				border-radius: 100%;
				margin-top: 2rem;
				z-index: 5;
				cursor: pointer;
			}
			.dot_grey{
				width: 3.6875rem;
				height: 3.6875rem;
				border-radius: 100%;
				margin-top: 2rem;
				background: #F1F1F1;
				z-index: 5;
				cursor: pointer;
			}
			.tri{
				width: 0;
				height: 0;
				border-right: 0.9375rem solid transparent;
				border-left: 0.9375rem solid transparent;
				border-top: 0.9375rem solid #FFFFFF;
				position: absolute;
				bottom: -0.9rem;
			}
			.tri_hide{
				display: none;
			}
			.tri::after{
				content: '';
				     position: absolute;
				     // top: 0;
				     left: -0.9rem;
				     border-left: 0.9375rem solid transparent;
				     border-right: 0.9375rem solid transparent;
				     border-top: 0.9375rem  solid rgba(201,201,201,0.53);
				     position: absolute;
				   
				     z-index: -1;
				     filter: blur(2px);
					 bottom: -0.2rem;
					 
			}
			.line_dark{
				width: 75rem;
				height: 0.8125rem;
				background-color: #F2F2F2;
				position: absolute;
				border-radius: 1rem;
				bottom: 1.4rem;
			}
	}
	.qualify_container{	
	background: #F9FAFC;
	margin-top: 1rem;
	padding-bottom: 4rem;
	.qualify_list{
		display: flex;
		width: 75rem;
		margin: 0 auto;
		justify-content: space-between;
	}
	.qualify_box_img{
		width: 280px;
		height: 377px;
	}
	.qualify_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		}
		
	}
	.kyx_container{
		width: 100%;
		height: 55.875rem;
		margin-top: 13rem;
		display: flex;
		flex-direction: column;
		background: linear-gradient(144deg, #54A1FD 0%, #2A68F9 100%);
		align-items: center;
		justify-content: center;
		position: relative;
		.kyx_detail_top{
			position: absolute;
			top: -7rem;
			display: flex;
			width: 75rem;
			height: 14.4375rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 10px 5px rgba(222,222,222,0.5);
			display: flex;
			justify-content: space-around;
			align-items: center;
		}
		.kyx_detail_top_title{
			font-size: 3.75rem;
			font-family: GothicMB101Pro-Regular, GothicMB101Pro;
			font-weight: 400;
			color: #666666;
			opacity: 0.6;
			margin: 0;
		}
		.kyx_detail_top_title_sup{
			font-size: 1.875rem;
			font-family: GothicMB101Pro-Regular, GothicMB101Pro;
			font-weight: 400;
			color: #666666;
			opacity: 0.6;
		
		}
		.kyx_detail_top_msg{
			font-size: 1.125rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.kyx_title{
			font-size: 2.25rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.kyx_msg{
			font-size: 1.625rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			width: 68.125rem;
		}
	}
	.mask{
		position:fixed;
		top:0;
		left:0;
		bottom:0;
		right:0;
		z-index:10;
		background-color: #000000;
	    opacity: .6;
	}
	// 内容层 z-index要比遮罩大，否则会被遮盖
	.videomasks{
	    max-width: 1200px;
	    position: fixed;
	    left: 50%;
	    top: 50%;
	    z-index: 20;
	    transform: translate(-50%,-50%);
	  }
	  .videomasks video{
	    width: 100%;
	    height: 100%;
	  }
</style>
